import { Component, OnInit } from '@angular/core';
import { Order } from 'src/app/models/order';
import { OrderService } from 'src/app/services/order.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/product.service';
import { Customer } from 'src/app/models/customer';
import { Product } from 'src/app/models/product';
import { CustomerAddress } from 'src/app/models/customer-address';
import { NgbDateAdapter, NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UnitType } from 'src/app/models/unit-type';
import { Presentation } from 'src/app/models/presentation';
import { UnitTypeService } from 'src/app/services/unit-type.service';
import { PresentationsService } from 'src/app/services/presentations.service';
import { TimeNativeAdapter } from 'src/app/adapters/native-time-adapter';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';

@Component({
  selector: 'app-order-create',
  templateUrl: './order-create.component.html',
  styleUrls: ['./order-create.component.css'],
  providers: [
    {provide: NgbDateAdapter, useClass: NativeDateAdapter}, 
    {provide: NgbTimeAdapter, useClass: TimeNativeAdapter}
  ]
})
export class OrderCreateComponent implements OnInit {
  order:Order = new Order();
  loading:boolean = false;
  customers:Customer[] = [];
  sourceCustomers:Customer[] = [];
  customerAddresses:CustomerAddress[] = [];
  sourceCustomerAddresses:CustomerAddress[] = [];
  products:Product[] = [];
  unitTypes:UnitType[] = [];
  presentations:Presentation[] = [];

  constructor(private orderServ:OrderService, private utl:UtilitiesService, private router:Router, private custServ:CustomerService, private prodServ:ProductService, private unitTypeServ:UnitTypeService, private presServ:PresentationsService, private toastr: ToastrManager, private logisticEv:LogisticEventsService) { }

  async ngOnInit() {
    this.loading = true;
    this.custServ.getCustomers('Cliente', true).then(customers => {
      this.customers = customers;
      if(this.customers.length) {
        this.order.customer = this.customers[0];
        this.order.customer_id = this.customers[0].id;
      }
      this.customerAddresses = this.customers[0].directions;
      if(this.customerAddresses.length) {
        this.order.customer_address = this.customers[0].directions[0];
        this.order.customer_address_id = this.customers[0].directions[0].id;
      }
      this.loading = false;
    });

    this.custServ.getCustomers('Intercompañia').then(sourceCustomers => {
      this.sourceCustomers = sourceCustomers;
      this.initDirections();
    });

    this.prodServ.getProducts().then(products => {
      this.products = products;
      if(this.products.length) {
        this.order.product = this.products[0];
        this.order.product_id = this.products[0].id;
      }
    });
    
    this.presServ.getPresentations().then(presentations => {
      this.presentations = presentations.filter(pr => pr.name != 'Vacio');
      if(this.presentations.length) {
        this.order.presentation = this.presentations[0];
        this.order.presentation_id = this.presentations[0].id;
      }
    });
    this.unitTypeServ.getTypes().then(unitTypes => {
      this.unitTypes = unitTypes;
      if(this.unitTypes.length) {
        this.order.unit_type = this.unitTypes[0];
        this.order.unit_type_id = this.unitTypes[0].id;
      }
    });
  }

  initDirections() {
    this.order.source_customer = this.sourceCustomers.find(x => x.id == 6);
    this.order.source_customer_id = this.order.source_customer.id;
    this.sourceCustomerAddresses = this.order.source_customer.directions;
    if(this.sourceCustomerAddresses.length) {
      this.order.source_customer_address = this.order.source_customer.directions[0];
      this.order.source_customer_address_id = this.order.source_customer.directions[0].id;
    }
  }

  addressDetail() : string {
    let addr = this.order.customer_address;
    return addr.street + ', ' + addr.colony + ', ' + addr.city + ', C.P.: ' + addr.zip_code + ', ' + addr.locality + ', ' + addr.state;
  }

  async changeCustomer() {
    this.customerAddresses = this.order.customer.directions;
    if(this.customerAddresses.length) {
      this.order.customer_address = this.customerAddresses[0];
      this.order.customer_address_id = this.customerAddresses[0].id;
    }
  }

  changeSourceCustomer() {
    this.sourceCustomerAddresses = this.order.source_customer.directions;
    if(this.sourceCustomerAddresses.length) {
      this.order.source_customer_address = this.sourceCustomerAddresses[0];
      this.order.source_customer_address_id = this.sourceCustomerAddresses[0].id;
    }
  }

  async save(event) {
    event.preventDefault();

    if (this.order.presentation.name == 'Vacio') {
      this.toastr.infoToastr('No se pueden crear ordenes con presentación Vacio');
      return;
    }

    if (this.order.ton <= 0) {
      this.toastr.infoToastr("No se pueden crear ordenes con peso menor o igual a cero");
      return;
    }
    
    try {
      this.loading = true;
      this.order.customer_address_id = this.order.customer_address.id;
      this.order.source_customer_id = this.order.source_customer.id;
      this.order.source_customer_address_id = this.order.source_customer_address.id;
      this.order.customer_id = this.order.customer.id;
      this.order.product_id = this.order.product.id;
      this.order.unit_type_id = this.order.unit_type.id;
      this.order.presentation_id = this.order.presentation.id;
      let or = await this.orderServ.postOrder(this.order);
      this.toastr.successToastr("Se ha creado la orden with NO: " + or.id);

      this.logisticEv.sendOrderCreated(or);

      //instance order
      this.order = new Order();
      this.order.customer = this.customers[0];
      this.order.customer_id = this.customers[0].id;
      this.order.customer_address = this.customers[0].directions[0];
      this.order.customer_address_id = this.customers[0].directions[0].id;
      this.initDirections();
      this.order.product = this.products[0];
      this.order.product_id = this.products[0].id;
      this.order.presentation = this.presentations[0];
      this.order.presentation_id = this.presentations[0].id;
      this.order.unit_type = this.unitTypes[0];
      this.order.unit_type_id = this.unitTypes[0].id;

      this.loading = false;
    } catch (e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    }
  }

}
